import useMetaStore from '@/stores/meta'
import useUserStore from '@/stores/user'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { storeToRefs } from 'pinia'
import router from './index'
import RouteNames from './route-names'

NProgress.configure({
  showSpinner: false,
  easing: 'ease',
  minimum: 0.3,
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const userStore = useUserStore()
  const { token } = storeToRefs(userStore)

  // 没有登录信息时，所有非登录页面都重定向登录页面
  if (!token.value && to.name !== RouteNames.Login) {
    const { redirectRoute } = storeToRefs(useMetaStore())
    redirectRoute.value = to

    next({ name: RouteNames.Login })
    return
  }

  // 错误处理页面
  if (/^\/error/.test(to.path)) {
    next()
    return
  }

  if (token.value) {
    // 当登录成功时，如果跳到登录页面则重定向到首页
    if (to.name === RouteNames.Login) {
      // 如果用户需要设置密码，允许访问登录页面（用于设置密码）
      if (userStore.needsPasswordSetup) {
        next()
        return
      }
      next({ name: RouteNames.Home })
      return
    }

    // 检查是否需要设置密码（除了登录页面外的所有页面）
    if (userStore.needsPasswordSetup && to.name !== RouteNames.Login) {
      // 保存用户想要访问的页面
      const { redirectRoute } = storeToRefs(useMetaStore())
      redirectRoute.value = to
      
      // 重定向到登录页面进行密码设置
      next({ name: RouteNames.Login })
      return
    }
  }
  
  // 2.动态设置标题
  const title = import.meta.env.VITE_APP_TITLE;
  document.title = to.meta.label ? `${to.meta.label} - ${title}` : title;

  next()
})

router.afterEach(() => {
  NProgress.done()
})

router.onError(() => {
  NProgress.done()
})
